import addDays from 'date-fns/addDays';
import endOfWeek from 'date-fns/endOfWeek';
import startOfWeek from 'date-fns/startOfWeek';
import subDays from 'date-fns/subDays';
import dayjs from 'dayjs';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import 'rsuite/dist/rsuite.css';
import {resetResponse, setAppointmentDate, setDoctorsDetailsList, sidebar} from '../../Redux/Slice/rootSlice';
import {fetchPatientBill, getDashboardData, getDoctorsList} from '../../Redux/Thunk/Actions';
import '../../styles/Home.scss';

export default function Home(props) {
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const userdata = useSelector(state => state.counter.userdata);
  const [dcount, setdcount] = useState(0);
  const [pcount, setpcount] = useState(0);
  const [acount, setacount] = useState(0);
  const [doctorcount, setdoctorcount] = useState(0);
  const [patientcount, setpatientcount] = useState(0);
  const [appoinmentcount, setappoinmentcount] = useState(0);
  const [todaysTotal, setTodaysTotal] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  const [range, setrange] = useState([gt, it]);
  useEffect(() => {
    props.loaderchange('true');
    const dataPayload = {
      date_gt: range[0],
      date_lt: range[1]
    };
    const currentDate = new Date();

    // Extract date components
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Format the date as needed
    const formattedDate = `${year}-${month}-${day}`;
    // const appointmentFormattedDate = `${year}-${month}-${day}`;

    const billTotalPayload = {
      page: 1,
      page_size: 50,
      search: '',
      from_date: formattedDate,
      // to_date: endDate,
      range: false
    };

    dispatch(setAppointmentDate(dayjs().format('YYYY-MM-DD')));
    (async () => {
      const doctorsList = await dispatch(getDoctorsList());
      let docDetails = doctorsList.payload.data;
      dispatch(setDoctorsDetailsList(docDetails));
    })();

    const fetchData = async () => {
      const fetchDashboard = getDashboardData(dataPayload);
      const response = await dispatch(fetchDashboard);
      console.log(response, 'test');
      const patentDetails = fetchPatientBill(billTotalPayload);

      const responsePatentDetails = await dispatch(patentDetails);
      if (response.payload.status?.code === 200) {
        setTodaysTotal(responsePatentDetails.payload.data.total_bill_price === null ? 0 : responsePatentDetails.payload.data.total_bill_price);
      }
      if (response.payload.status.code === 200) {
        setdcount(response.payload.data.doctor_count);
        const intervalId1 = setInterval(() => {
          if (response.payload.data.doctor_count != 0) {
            setdoctorcount(prevCount => {
              if (prevCount < response.payload.data.doctor_count) {
                return prevCount + 1;
              } else {
                clearInterval(intervalId1);
                return prevCount;
              }
            });
          }
        });

        setpcount(response.payload.data.patient_count);
        const intervalId3 = setInterval(() => {
          if (response.payload.data.appointment_count != 0) {
            setappoinmentcount(prevCount => {
              if (prevCount < response.payload.data.appointment_count) {
                return prevCount + 1;
              } else {
                clearInterval(intervalId3);
                return prevCount;
              }
            });
          }
        });
        setacount(response.payload.data.appointment_count);
        const intervalId2 = setInterval(() => {
          if (response.payload.data.patient_count != 0) {
            setpatientcount(prevCount => {
              if (prevCount < response.payload.data.patient_count) {
                return prevCount + 1;
              } else {
                clearInterval(intervalId2);
                return prevCount;
              }
            });
          }
        });
        dispatch(resetResponse(''));
        props.loaderchange('false');
      }
    };
    fetchData();
    //   .catch((error) => {
    //     console.log(error);
    //     props.loaderchange("false");
    //     // setdtPageindex(dtpageindex-1)
    //     props.popupalert("true");
    //     props.popuptext("No Data Available");
    //     setTimeout(() => {
    //       props.popupalert("false");
    //     }, 2000);
    //   });
  }, [range]);
  function convert(str) {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  }
  // console.log(acount,"acount");

  const handlechangedate = (name, value) => {
    if (value != null) {
      setrange(oldArray => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {};
  const predefinedBottomRanges = [
    {
      label: 'Today',
      value: [new Date(), new Date()],
      placement: 'left'
    },
    {
      label: 'Yesterday',
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: 'left'
    },
    {
      label: 'This week',
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: 'left'
    },
    {
      label: 'Last 30 days',
      value: [subDays(new Date(), 29), new Date()],
      placement: 'left'
    },

    {
      label: 'Last week',
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [addDays(startOfWeek(start, {weekStartsOn: 0}), -7), addDays(endOfWeek(start, {weekStartsOn: 0}), -7)];
      },
      appearance: 'default'
    },
    {
      label: 'Next week',
      closeOverlay: false,
      value: (value, index) => {
        console.log(value);
        const [start = new Date()] = value[index] || [];
        return [addDays(startOfWeek(start, {weekStartsOn: 0}), 7), addDays(endOfWeek(start, {weekStartsOn: 0}), 7)];
      },
      appearance: 'default'
    }
  ];

  return (
    <>
      <div className={sideactive ? 'dashboard-main-sa' : 'dashboard-main'}>
        <div class='page-header'>
          <div class='row'>
            <div class='col-sm-12'>
              <h3 class='page-title'>{'Welcome ' + localStorage.getItem('role') + '!'}</h3>
              <ul class='breadcrumb' style={{justifyContent: 'space-between'}}>
                <li class='breadcrumb-item active'>Dashboard</li>
                <li>
                  {' '}
                  {/* <div className="datepicker_dash">
                    <DateRangePicker
                      defaultValue={[
                        new Date(new Date().setDate(today.getDate() - 30)),
                        new Date(),
                      ]}
                      disabledDate={(date) => isAfter(date, new Date())}
                      editable={false}
                      appearance="default"
                      placement="bottomEnd"
                      size="lg"
                      ranges={predefinedBottomRanges}
                      placeholder="From - To"
                      style={{ width: 270, padding: 10 }}
                      onClean={(e) => cleaningrange(e)}
                      onChange={(e) => {
                        if (e != null) {
                          setrange([]);
                          setdoctorcount(0);
                          setpatientcount(0);
                          setappoinmentcount(0);
                          e.forEach((newValue) => {
                            var tzoffset =
                              new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                            var localISOTime = new Date(newValue - tzoffset)
                              .toISOString()
                              .slice(0, -1);
                            handlechangedate("validtill", localISOTime);
                          });
                        }
                      }}
                    />
                  </div> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='row'>
          {/* <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-primary border-primary">
                    <i class="bi bi-person-fill-add"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{doctorcount}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Doctors</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${doctorcount / 10}%` }}
                      aria-valuenow={doctorcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className='col-xl-4 col-sm-6 col-12 '>
            <div class='card'>
              <div
                class='card-body'
                style={{padding: '1.5rem', cursor: 'pointer'}}
                onClick={() => {
                  dispatch(sidebar('Patient Details'));
                  navigate('/Patients');
                }}>
                <div class='dash-widget-header'>
                  <span class='dash-widget-icon text-success'>
                    <i class='bi bi-person-bounding-box'></i>
                  </span>
                  <div class='dash-count'>
                    <h3>{patientcount}</h3>
                    {/* <h3>{pcount}</h3> */}
                  </div>
                </div>
                <div class='dash-widget-info'>
                  <h6 class='text-muted'>Patients</h6>
                  <div class='progress progress-sm'>
                    <div class='progress-bar bg-success' style={{width: `${patientcount / 10}%`}} aria-valuenow={patientcount} aria-valuemin='0' aria-valuemax='100%'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {userdata.role === 'Admin' && (
            <div className='col-xl-4 col-sm-6 col-12 '>
              <div class='card' style={{height: '85%'}}>
                <div class='card-body' style={{padding: '1.5rem'}}>
                  <div class='dash-widget-header'>
                    <span class='dash-widget-icon text-success' style={{color: ''}}>
                      {/* <i class="bi bi-person-bounding-box"></i> */}
                      <i class='bi bi-receipt'></i>
                    </span>
                    <div class='dash-count'>
                      <h3>
                        {todaysTotal}
                        <span>&nbsp;₹</span>
                      </h3>

                      {/* <h3>{pcount}</h3> */}
                    </div>
                  </div>
                  <div class='dash-widget-info'>
                    <h6 class='text-muted'>
                      Today's Billing Overview&nbsp;
                      <strong>({dayjs().format('DD-MM-YYYY')})</strong>
                    </h6>

                    {/* <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-success"
                      style={{ width: `${patientcount / 10}%` }}
                      aria-valuenow={patientcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-person-vcard-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{appoinmentcount}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Appointment</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${appoinmentcount / 10}%` }}
                      aria-valuenow={appoinmentcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="col-xl-3 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-warning border-warning">
                    <i class="bi bi-currency-rupee"></i>
                  </span>
                  <div class="dash-count">
                    <h3>$62523</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Revenue</h6>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-warning w-50"></div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
